import Field from './Field';

export default class extends Field {
    constructor(element, parent, props) {
        super(element, parent, props);
    }

    getValue() {
        return this._input.is(':checked');
    }

    setValue(value = '') {
        this._input.prop('checked', !!Number(value));
        return this;
    }
}
